import { Injectable, Injector } from '@angular/core';
import {
	HttpEvent,
	HttpHandler,
	HttpInterceptor,
	HttpRequest,
	HttpResponse,
} from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable, of } from 'rxjs';
import * as login from '../../../mock/login.json';
import * as timegraph from '../../../mock/timegraph.json';
import * as testquestions from '../../../mock/testquestions.json';
import * as getOrgs from '../../../mock/getOrgs.json';
import * as submitResult from '../../../mock/phonicscoresubmit.json';
import { AuthenticationService } from '../_services/authentication.service';
import * as testHistory from '../../../mock/testHistory.json';
import * as readingAchievement from '../../../mock/getReadingAchievement.json';
import * as progressreport from '../../../mock/progressreport.json';
import * as postBaselineData from '../../../mock/postBaselineProgress.json';
import * as notes from '../../../mock/notes.json';
const urls = [
	{
		url: `${environment.apiUrl}/main/getStudentTimeGraph/`,
		json: timegraph,
	},
	// {
	//   url: `${environment.apiUrl}/main/getPhonicsTestQuestions/`,
	//   json: testquestions
	// },
	{
		url: `${environment.apiUrl}/main/submitPhonicsScore/`,
		json: submitResult,
	},
	{
		url: `${environment.apiUrl}/main/notes/`,
		json: notes,
	},
	{
		url: `${environment.apiUrl}/main/getTestHistory/`,
		json: testHistory,
	},
	{
		url: `${environment.apiUrl}/main/getReadingAchievement/`,
		json: readingAchievement,
	},
	{
		url: `${environment.apiUrl}/main/getProgressReport/`,
		json: progressreport,
	},
	{
		url: `${environment.apiUrl}/main/getProgressAfterBaseline/`,
		json: postBaselineData,
	},
];

@Injectable()
export class HttpMockRequestInterceptor implements HttpInterceptor {
	constructor(
		private injector: Injector,
		private authenticationService: AuthenticationService,
	) {}

	intercept(
		request: HttpRequest<any>,
		next: HttpHandler,
	): Observable<HttpEvent<any>> {
		for (const element of urls) {
			if (request.url === element.url) {
				console.log('Loaded from json : ' + request.url);
				return of(
					new HttpResponse({
						status: 200,
						body: (element.json as any).default,
					}),
				);
			}
		}
		console.log('Loaded from http call :' + request.url);
		return next.handle(request);
	}
}
